import type { DetectedHdpeContent, EvidenceUploadMode, HDPEComposition, SimpleMaterialQualityCategory } from 'api';
import { useTranslation } from 'i18n';
import { Link } from 'react-router-dom';
import { DataCard } from 'ui';
import { Insights } from 'ui/icons';

import { AdminAiVersionTitle } from '../../../breakdowns/components/AdminAiVersionTitle/AdminAiVersionTitle';
import { HDPECompositionBreakdown } from '../../../breakdowns/components/HDPECompositionBreakdown/HDPECompositionBreakdown';
import { NoAnalysisAlert } from '../../../breakdowns/components/NoAnalysisAlert/NoAnalysisAlert';
import { RepresentativeEvidenceSection } from '../../../breakdowns/components/PETRepresentativeEvidenceSection/PETRepresentativeEvidenceSection';

type Props = {
  detectedHdpeContent?: DetectedHdpeContent;
  hdpeComposition?: HDPEComposition;
  isLoading?: boolean;
  parentId?: number;
  uploadMode?: EvidenceUploadMode;
  sessionLink?: string;
  sessionName?: string;
  latestRunAIVersion?: string;
  materialCategory?: Pick<SimpleMaterialQualityCategory, 'id' | 'name'> | null;
};

export const HDPECompositionDataCard = ({
  detectedHdpeContent,
  hdpeComposition,
  isLoading,
  parentId,
  uploadMode,
  sessionLink,
  sessionName,
  latestRunAIVersion,
  materialCategory,
}: Props) => {
  const { t } = useTranslation('features');
  return (
    <DataCard
      isLoading={isLoading}
      slotProps={{
        header: {
          avatar: <Insights />,
          title: (
            <AdminAiVersionTitle
              title={t('dataCards.hdpeComposition.aiBaleAnalysisTitle')}
              version={latestRunAIVersion}
            />
          ),
        },
      }}
    >
      {sessionLink && sessionName ? (
        <DataCard.Item title={t('dataCards.hdpeComposition.reportTitle')} colSpan={6}>
          <Link to={sessionLink}>{sessionName}</Link>
        </DataCard.Item>
      ) : null}

      <DataCard.Item colSpan={12}>
        {hdpeComposition ? (
          <HDPECompositionBreakdown composition={hdpeComposition} />
        ) : (
          <NoAnalysisAlert aiModel="hdpe" />
        )}
      </DataCard.Item>

      {detectedHdpeContent ? (
        <DataCard.Item colSpan={12}>
          <RepresentativeEvidenceSection
            detectedContent={detectedHdpeContent}
            parentId={parentId}
            uploadMode={uploadMode}
            materialCategory={materialCategory}
          />
        </DataCard.Item>
      ) : null}
    </DataCard>
  );
};
